import * as e from "@angular/core";
import { Injectable as t, Optional as i, Component as o, ChangeDetectionStrategy as n, Input as r, NgModule as l } from "@angular/core";
import * as a from "@angular/common";
import { CommonModule as s } from "@angular/common";
import * as g from "@angular/common/http";
import { HttpClientModule as p } from "@angular/common/http";
import { map as d, catchError as c, of as u, BehaviorSubject as $ } from "rxjs";
import * as m from "@angular/platform-browser";
const _c0 = a0 => ({
  "background-image": a0
});
const _c1 = a0 => ({
  "ngx-lite-with-title": a0
});
function NgxLiteVimeoComponent_div_0_iframe_1_Template(rf, ctx) {
  if (rf & 1) {
    e.ɵɵelement(0, "iframe", 5);
  }
  if (rf & 2) {
    const ctx_r1 = e.ɵɵnextContext(2);
    e.ɵɵproperty("src", ctx_r1._videoUrl, e.ɵɵsanitizeResourceUrl);
  }
}
function NgxLiteVimeoComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    e.ɵɵelementStart(0, "div", 6);
    e.ɵɵelement(1, "button", 7);
    e.ɵɵelementEnd();
  }
}
function NgxLiteVimeoComponent_div_0_p_4_Template(rf, ctx) {
  if (rf & 1) {
    e.ɵɵelementStart(0, "p", 8);
    e.ɵɵtext(1);
    e.ɵɵelementEnd();
  }
  if (rf & 2) {
    const vimeoBanner_r3 = e.ɵɵnextContext().ngIf;
    e.ɵɵadvance();
    e.ɵɵtextInterpolate1(" ", vimeoBanner_r3.title, " ");
  }
}
function NgxLiteVimeoComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = e.ɵɵgetCurrentView();
    e.ɵɵelementStart(0, "div", 1);
    e.ɵɵlistener("click", function NgxLiteVimeoComponent_div_0_Template_div_click_0_listener() {
      e.ɵɵrestoreView(_r1);
      const ctx_r1 = e.ɵɵnextContext();
      return e.ɵɵresetView(ctx_r1._showIframe$.next(true));
    });
    e.ɵɵtemplate(1, NgxLiteVimeoComponent_div_0_iframe_1_Template, 1, 1, "iframe", 2);
    e.ɵɵpipe(2, "async");
    e.ɵɵtemplate(3, NgxLiteVimeoComponent_div_0_div_3_Template, 2, 0, "div", 3)(4, NgxLiteVimeoComponent_div_0_p_4_Template, 2, 1, "p", 4);
    e.ɵɵelementEnd();
  }
  if (rf & 2) {
    const vimeoBanner_r3 = ctx.ngIf;
    const ctx_r1 = e.ɵɵnextContext();
    e.ɵɵclassMapInterpolate1("ngx-lite-video", ctx_r1.styleClass ? " " + ctx_r1.styleClass : "", "");
    e.ɵɵproperty("ngStyle", e.ɵɵpureFunction1(10, _c0, vimeoBanner_r3.bannerSrc))("ngClass", e.ɵɵpureFunction1(12, _c1, ctx_r1.showTitle));
    e.ɵɵadvance();
    e.ɵɵproperty("ngIf", e.ɵɵpipeBind1(2, 8, ctx_r1._showIframe$));
    e.ɵɵadvance(2);
    e.ɵɵproperty("ngIf", !ctx_r1._showIframe$.value);
    e.ɵɵadvance();
    e.ɵɵproperty("ngIf", ctx_r1.showTitle && !ctx_r1._showIframe$.value);
  }
}
function NgxLiteYoutubeComponent_iframe_1_Template(rf, ctx) {
  if (rf & 1) {
    e.ɵɵelement(0, "iframe", 4);
  }
  if (rf & 2) {
    const ctx_r0 = e.ɵɵnextContext();
    e.ɵɵproperty("src", ctx_r0._videoUrl, e.ɵɵsanitizeResourceUrl);
  }
}
function NgxLiteYoutubeComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    e.ɵɵelementStart(0, "div", 5);
    e.ɵɵelement(1, "button", 6);
    e.ɵɵelementEnd();
  }
}
function NgxLiteYoutubeComponent_p_4_Template(rf, ctx) {
  if (rf & 1) {
    e.ɵɵelementStart(0, "p", 7);
    e.ɵɵtext(1);
    e.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = e.ɵɵnextContext();
    e.ɵɵadvance();
    e.ɵɵtextInterpolate1(" ", ctx_r0.videoTitle, " ");
  }
}
class NgxLiteVideoGeneralService {
  constructor(e, t) {
    this.__domSanitizer = e, this.__http = t, this.__youtubeSizes = {
      sd: "sddefault",
      medium: "mqdefault",
      high: "hqdefault",
      max: "maxresdefault"
    }, this.__thumbHelper = {
      max: "thumbnail_large",
      high: "thumbnail_large",
      medium: "thumbnail_medium",
      sd: "thumbnail_small"
    };
  }
  getYouTubeBanner(e, t) {
    return `https://img.youtube.com/vi/${e}/${this.__youtubeSizes[t]}.jpg`;
  }
  getYouTubeUrl(e, t, i, o, n, r) {
    return this.__domSanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube-nocookie.com/embed/${e}?autoplay=1&controls=${t ? "1" : "0"}${o ? "&playlist=" + e + "&loop=1" : ""}${n ? "&start=" + n : ""}${r ? "&end=" + r : ""}${i ? "&fs=1" : "&fs=0"}`);
  }
  getVimeoVideoUrl(e, t, i, o) {
    return this.__domSanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/${e}?autoplay=1${t ? "&controls=true" : "&controls=false"}${i ? "&loop=true" : ""}${o ? "&background=true" : ""}`);
  }
  getVimeoBanner(e, t) {
    return this.__http.get(`https://vimeo.com/api/v2/video/${e}.json`).pipe(d(e => ({
      bannerSrc: `url(${e[0][this.__thumbHelper[t]]})`,
      title: e[0].title
    })), c(() => u({
      bannerSrc: "",
      title: ""
    })));
  }
  hasNoVideoId(e) {
    if (!e) throw Error("Video ID MUST be provided");
  }
}
NgxLiteVideoGeneralService.ɵfac = function NgxLiteVideoGeneralService_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || NgxLiteVideoGeneralService)(e.ɵɵinject(m.DomSanitizer), e.ɵɵinject(g.HttpClient, 8));
}, NgxLiteVideoGeneralService.ɵprov = /* @__PURE__ */e.ɵɵdefineInjectable({
  token: NgxLiteVideoGeneralService,
  factory: NgxLiteVideoGeneralService.ɵfac
}), (() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NgxLiteVimeoComponent {
  constructor(e) {
    this.__ngxService = e, this._showIframe$ = new $(!1), this.thumbQuality = "high", this.showTitle = !1, this.hasControls = !0, this.loop = !1, this.isBackground = !1;
  }
  ngOnInit() {
    this.init();
  }
  ngOnChanges() {
    this.init(), this._showIframe$.next(!1);
  }
  init() {
    this.__ngxService.hasNoVideoId(this.videoId), this._vimeoBanner$ = this.__ngxService.getVimeoBanner(this.videoId, this.thumbQuality), this._videoUrl = this.__ngxService.getVimeoVideoUrl(this.videoId, this.hasControls, this.loop, this.isBackground);
  }
}
NgxLiteVimeoComponent.ɵfac = function NgxLiteVimeoComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || NgxLiteVimeoComponent)(e.ɵɵdirectiveInject(NgxLiteVideoGeneralService));
}, NgxLiteVimeoComponent.ɵcmp = /* @__PURE__ */e.ɵɵdefineComponent({
  type: NgxLiteVimeoComponent,
  selectors: [["ngx-lite-vimeo"]],
  inputs: {
    videoId: "videoId",
    thumbQuality: "thumbQuality",
    showTitle: "showTitle",
    hasControls: "hasControls",
    loop: "loop",
    isBackground: "isBackground",
    styleClass: "styleClass"
  },
  features: [e.ɵɵProvidersFeature([NgxLiteVideoGeneralService]), e.ɵɵNgOnChangesFeature],
  decls: 2,
  vars: 3,
  consts: [[3, "ngStyle", "class", "ngClass", "click", 4, "ngIf"], [3, "click", "ngStyle", "ngClass"], ["width", "640", "height", "360", "frameborder", "0", "allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", "allowfullscreen", "", 3, "src", 4, "ngIf"], ["class", "ngx-lite-video__play", 4, "ngIf"], ["class", "ngx-lite-video__title", 4, "ngIf"], ["width", "640", "height", "360", "frameborder", "0", "allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", "allowfullscreen", "", 3, "src"], [1, "ngx-lite-video__play"], ["aria-label", "Vimeo Play Button", 1, "vimeo-logo"], [1, "ngx-lite-video__title"]],
  template: function NgxLiteVimeoComponent_Template(rf, ctx) {
    if (rf & 1) {
      e.ɵɵtemplate(0, NgxLiteVimeoComponent_div_0_Template, 5, 14, "div", 0);
      e.ɵɵpipe(1, "async");
    }
    if (rf & 2) {
      e.ɵɵproperty("ngIf", e.ɵɵpipeBind1(1, 1, ctx._vimeoBanner$));
    }
  },
  dependencies: [a.NgIf, a.NgStyle, a.NgClass, a.AsyncPipe],
  styles: [".ngx-lite-video[_ngcontent-%COMP%]{position:relative;width:100%;height:0;padding:56.25% 0 0;background:center/cover no-repeat #000;cursor:pointer}.ngx-lite-video[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box;margin:0;padding:0}.ngx-lite-video[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;border:0}.ngx-lite-video__title[_ngcontent-%COMP%]{position:absolute;top:20px;left:20px;color:#fff;font-size:18px;font-family:YouTube Noto,Roboto,Arial,Helvetica,sans-serif;line-height:1.3}.ngx-lite-video__play[_ngcontent-%COMP%]{z-index:2;display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%}.ngx-lite-with-title[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:0;background:linear-gradient(180deg,rgba(0,0,0,.7904411765) 0%,rgba(0,0,0,0) 35%);width:100%;height:100%}.ngx-lite-video__play[_ngcontent-%COMP%]   .vimeo-logo[_ngcontent-%COMP%]{all:unset;width:72px;height:48px;background:rgba(23,35,34,.75);opacity:.8;border-radius:8px;transition:all .2s cubic-bezier(0,0,.2,1);display:flex;align-items:center;justify-content:center}.ngx-lite-video__play[_ngcontent-%COMP%]   .vimeo-logo[_ngcontent-%COMP%]:after{content:\"\";border-color:transparent transparent transparent #fff;border-style:solid;border-width:10px 0 10px 20px}.ngx-lite-video__play[_ngcontent-%COMP%]:hover   .vimeo-logo[_ngcontent-%COMP%]{background:#00adef;opacity:1}"],
  changeDetection: 0
}), (() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NgxLiteVimeoModule {}
NgxLiteVimeoModule.ɵfac = function NgxLiteVimeoModule_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || NgxLiteVimeoModule)();
}, NgxLiteVimeoModule.ɵmod = /* @__PURE__ */e.ɵɵdefineNgModule({
  type: NgxLiteVimeoModule
}), NgxLiteVimeoModule.ɵinj = /* @__PURE__ */e.ɵɵdefineInjector({
  imports: [[s, p]]
}), (() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NgxLiteYoutubeComponent {
  constructor(e) {
    this.__ngxService = e, this._showIframe$ = new $(!1), this.thumbQuality = "high", this.hasControls = !0, this.loop = !1, this.allowFullScreen = !0;
  }
  ngOnInit() {
    this.init();
  }
  ngOnChanges() {
    this.init(), this._showIframe$.next(!1);
  }
  init() {
    this.__ngxService.hasNoVideoId(this.videoId), this._bannerSrc = `url(${this.__ngxService.getYouTubeBanner(this.videoId, this.thumbQuality)})`, this._videoUrl = this.__ngxService.getYouTubeUrl(this.videoId, this.hasControls, this.allowFullScreen, this.loop, this.start, this.end);
  }
}
NgxLiteYoutubeComponent.ɵfac = function NgxLiteYoutubeComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || NgxLiteYoutubeComponent)(e.ɵɵdirectiveInject(NgxLiteVideoGeneralService));
}, NgxLiteYoutubeComponent.ɵcmp = /* @__PURE__ */e.ɵɵdefineComponent({
  type: NgxLiteYoutubeComponent,
  selectors: [["ngx-lite-youtube"]],
  inputs: {
    videoId: "videoId",
    videoTitle: "videoTitle",
    thumbQuality: "thumbQuality",
    hasControls: "hasControls",
    loop: "loop",
    start: "start",
    allowFullScreen: "allowFullScreen",
    end: "end",
    styleClass: "styleClass"
  },
  features: [e.ɵɵProvidersFeature([NgxLiteVideoGeneralService]), e.ɵɵNgOnChangesFeature],
  decls: 5,
  vars: 14,
  consts: [[3, "click", "ngStyle", "ngClass"], ["width", "560", "height", "315", "title", "YouTube video player", "frameborder", "0", "allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;", "allowfullscreen", "", 3, "src", 4, "ngIf"], ["class", "ngx-lite-video__play", 4, "ngIf"], ["class", "ngx-lite-video__title", 4, "ngIf"], ["width", "560", "height", "315", "title", "YouTube video player", "frameborder", "0", "allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;", "allowfullscreen", "", 3, "src"], [1, "ngx-lite-video__play"], ["aria-label", "YouTube Play Button", 1, "youtube-logo"], [1, "ngx-lite-video__title"]],
  template: function NgxLiteYoutubeComponent_Template(rf, ctx) {
    if (rf & 1) {
      e.ɵɵelementStart(0, "div", 0);
      e.ɵɵlistener("click", function NgxLiteYoutubeComponent_Template_div_click_0_listener() {
        return ctx._showIframe$.next(true);
      });
      e.ɵɵtemplate(1, NgxLiteYoutubeComponent_iframe_1_Template, 1, 1, "iframe", 1);
      e.ɵɵpipe(2, "async");
      e.ɵɵtemplate(3, NgxLiteYoutubeComponent_div_3_Template, 2, 0, "div", 2)(4, NgxLiteYoutubeComponent_p_4_Template, 2, 1, "p", 3);
      e.ɵɵelementEnd();
    }
    if (rf & 2) {
      e.ɵɵclassMapInterpolate1("ngx-lite-video", ctx.styleClass ? " " + ctx.styleClass : "", "");
      e.ɵɵproperty("ngStyle", e.ɵɵpureFunction1(10, _c0, ctx._bannerSrc))("ngClass", e.ɵɵpureFunction1(12, _c1, ctx.videoTitle));
      e.ɵɵadvance();
      e.ɵɵproperty("ngIf", e.ɵɵpipeBind1(2, 8, ctx._showIframe$));
      e.ɵɵadvance(2);
      e.ɵɵproperty("ngIf", !ctx._showIframe$.value);
      e.ɵɵadvance();
      e.ɵɵproperty("ngIf", ctx.videoTitle && !ctx._showIframe$.value);
    }
  },
  dependencies: [a.NgStyle, a.NgClass, a.NgIf, a.AsyncPipe],
  styles: [".ngx-lite-video[_ngcontent-%COMP%]{position:relative;width:100%;height:0;padding:56.25% 0 0;background:center/cover no-repeat #000;cursor:pointer}.ngx-lite-video[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box;margin:0;padding:0}.ngx-lite-video[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;border:0}.ngx-lite-video__title[_ngcontent-%COMP%]{position:absolute;top:20px;left:20px;color:#fff;font-size:18px;font-family:YouTube Noto,Roboto,Arial,Helvetica,sans-serif;line-height:1.3}.ngx-lite-video__play[_ngcontent-%COMP%]{z-index:2;display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%}.ngx-lite-with-title[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:0;background:linear-gradient(180deg,rgba(0,0,0,.7904411765) 0%,rgba(0,0,0,0) 35%);width:100%;height:100%}.ngx-lite-video__play[_ngcontent-%COMP%]   .youtube-logo[_ngcontent-%COMP%]{all:unset;width:72px;height:48px;transition:all .2s cubic-bezier(0,0,.2,1);background:center/68px 48px no-repeat url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68 48'%3E%3Cpath fill='%23f00' fill-opacity='.9' d='M66.5 7.7c-.8-2.9-2.5-5.4-5.4-6.2C55.8.1 34 0 34 0S12.2.1 6.9 1.6c-3 .7-4.6 3.2-5.4 6.1a89.6 89.6 0 000 32.5c.8 3 2.5 5.5 5.4 6.3C12.2 47.9 34 48 34 48s21.8-.1 27.1-1.6c3-.7 4.6-3.2 5.4-6.1C68 35 68 24 68 24s0-11-1.5-16.3z'/%3E%3Cpath fill='%23fff' d='M45 24L27 14v20'/%3E%3C/svg%3E\");filter:grayscale(1)}.ngx-lite-video__play[_ngcontent-%COMP%]:hover   .youtube-logo[_ngcontent-%COMP%]{filter:none}"],
  changeDetection: 0
}), (() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NgxLiteYoutubeModule {}
NgxLiteYoutubeModule.ɵfac = function NgxLiteYoutubeModule_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || NgxLiteYoutubeModule)();
}, NgxLiteYoutubeModule.ɵmod = /* @__PURE__ */e.ɵɵdefineNgModule({
  type: NgxLiteYoutubeModule
}), NgxLiteYoutubeModule.ɵinj = /* @__PURE__ */e.ɵɵdefineInjector({
  imports: [[s]]
}), (() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { NgxLiteVimeoComponent, NgxLiteVimeoModule, NgxLiteYoutubeComponent, NgxLiteYoutubeModule };